import React from "react"
import { PropTypes } from "prop-types"
import ImageGallery from "react-image-gallery"
import Modal from "../../common/components/modal_dialog/modal_component"
import objectFitImages from "object-fit-images"
import StringHelper from "../../common/helpers/string_helper"
import "./Photo.scss"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"

export class Photo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpenModal: false,
      clickedPhotoIndex: 0
    }

    this.gallery = null

    this.setGalleryRef = (element) => {
      this.gallery = element
      this.adjustGallery()
    }
  }

  onSlideGallery() {
    this.adjustGallery()
  }

  adjustGallery() {
    if (this.gallery && this.gallery._imageGallery) {
      objectFitImages(
        this.gallery._imageGallery.querySelectorAll(
          ".image-gallery-slide-wrapper img"
        )
      )
    }
  }

  get imageWidth() {
    if (this._imageWidth) {
      return this._imageWidth
    }
    const pageWidth = window.innerWidth

    if (pageWidth) {
      this._imageWidth = pageWidth
    }
    return this._imageWidth
  }

  get thumbnailWidth() {
    if (this._thumbnailWidth) {
      return this._thumbnailWidth
    }
    const pageWidth = window.innerWidth

    if (pageWidth <= 768) {
      this._thumbnailWidth = 75
    } else {
      this._thumbnailWidth = 100
    }
    return this._thumbnailWidth
  }

  get devicePixelRatio() {
    if (this._devicePixelRatio) {
      return this._devicePixelRatio
    }
    if ("devicePixelRatio" in window) {
      this._devicePixelRatio = window.devicePixelRatio
    }
    return this._devicePixelRatio
  }

  /**
   *
   * @param {string} relativeUrl
   */
  makeAbsoluteUrl(relativeUrl) {
    const isAbsolute =
      relativeUrl &&
      (relativeUrl.startsWith("http://") || relativeUrl.startsWith("https://"))
    return (
      relativeUrl &&
      (isAbsolute
        ? relativeUrl
        : `${location.protocol}//${location.hostname}${relativeUrl}`)
    )
  }

  createImageArray() {
    return this.props.photos.map((photo) => {
      const caption = StringHelper.getPreferredLanguageString(
        photo.caption,
        languageHelper.pageLocale
      )
      if (photo.imgix) {
        return {
          original: `${photo.imgix}?auto=format&auto=compress${
            this.imageWidth ? `&w=${this.imageWidth}` : ``
          }&dpr=${this.devicePixelRatio}`,
          thumbnail: `${photo.imgix}?auto=format&auto=compress&w=100&dpr=${this.devicePixelRatio}`,
          description: caption
        }
      }
      return {
        original: this.makeAbsoluteUrl(photo.urls.large),
        thumbnail: this.makeAbsoluteUrl(photo.urls.small),
        description: caption
      }
    })
  }

  render() {
    const { t } = this.props

    const isPC = !navigator.userAgent.match(/iPhone|iPad|Android.+Mobile/) || false

    return (
      <div styleName="photo-area">
        {this.props.photos.slice(0, 4).map((photoObj, index) => {
          let photoWidth = 600

          switch (index) {
          case 3:
            photoWidth = 200
            break
          default:
            photoWidth -= 200 * index
          }

          const imgSrc = photoObj.imgix
            ? `${photoObj.imgix}?auto=format&fit=max&w=${photoWidth}`
            : photoObj.urls.medium

          const imgSrcset = photoObj.imgix
            ? `${imgSrc}&dpr=1 1x, ${imgSrc}&dpr=2 2x, ${imgSrc}&dpr=3 3x,`
            : null

          return (
            <div
              key={`image-${index}`}
              styleName={`image-${index}`}
              onClick={() => {
                this.setState({
                  isOpenModal: true,
                  clickedPhotoIndex: index
                })
              }}
            >
              <img
                styleName={`image-container ${isPC ? 'pc-only' : ''}`}
                srcSet={imgSrcset}
                src={imgSrc}
              />
              {index === 3 && this.props.photos.length > 4 &&
                <div styleName="overlay">
                  {`+${this.props.photos.length - 3} ${t('photo.more')}`}
                </div>
              }
            </div>
          )
        })}
        <Modal
          flag={this.state.isOpenModal}
          overlayColor="black"
        >
          <div styleName="image-gallery-container">
            <div styleName="slideshow-base">
              {this.state.isOpenModal && (
                <ImageGallery
                  ref={this.setGalleryRef}
                  items={this.createImageArray()}
                  showPlayButton={false}
                  showIndex={true}
                  onSlide={this.onSlideGallery.bind(this)}
                  startIndex={this.state.clickedPhotoIndex}
                />
              )}
              <div
                styleName="close-button"
                onClick={() => {
                  this.setState({ isOpenModal: false })
                }}
              />
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

Photo.propTypes = {
  photos: PropTypes.array.isRequired
}

Photo.defaultProps = {
  photos: []
}

export default compose(withNamespaces("listings"))(Photo)
